import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@nbg-globals/form-controls';
import { IBlockUserRequest } from '../../../classes/block-user';
import { AppSettings } from '../../../app.settings';

@Component({
	selector: 'lock-user-verify',
	template: require('./lock-user-verify.component.html'),
})
export class LockUserVerifyComponent {
	@Output() emitTerms: EventEmitter<boolean> = new EventEmitter();

	@Input() controls: FormGroup<IBlockUserRequest>;
	public isRebrading = AppSettings.isRebrading;

	hasAcceptedTerms = false;

	constructor() {}

	toggleSwitch(): void {
		this.hasAcceptedTerms = !this.hasAcceptedTerms;
		this.emitTerms.emit(this.hasAcceptedTerms);
	}
}
